import { Add } from "@mui/icons-material";
import { DropzoneArea } from "mui-file-dropzone";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(10),
    width: "100%",
    padding: "1rem",
    border: "none",
    borderRadius: "15px",
    backgroundColor: theme.palette.dropzone.background,

    "& p, span, svg": {
      color: theme.palette.primary.contrastText,
    },
  },
}));

const Dropzone = ({ ...props }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <DropzoneArea
        {...props}
        useChipsForPreview
        Icon={Add}
        dropzoneText={t("Click or drag and drop zip files here")}
        dropzoneClass={classes.root}
        showAlerts={false}
        maxFileSize={100000000}
      />
    </>
  );
};

export default Dropzone;
